import { render, staticRenderFns } from "./loading-indicator.vue?vue&type=template&id=28c9cf44&scoped=true"
import script from "./loading-indicator.vue?vue&type=script&lang=js"
export * from "./loading-indicator.vue?vue&type=script&lang=js"
import style0 from "./loading-indicator.vue?vue&type=style&index=0&id=28c9cf44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9cf44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
